import "../styles/ContactCard.css";

export default function ContactCard({ title, value, href }) {
  return (
    <section className="contact-card">
      <h2 className="contact-card-title">{title}</h2>
      {href ? (
        <a className="contact-card-value" href={href}>
          {value}
        </a>
      ) : (
        <p className="contact-card-value">{value}</p>
      )}
    </section>
  );
}
